module.exports = __webpack_public_path__ + "img/palm-pool-3.d60542c9.jpg";